import { Reveal } from "./Reveal";

const CHAPTERS = [
  {
    id: "manifesto-chapter-01",
    num: "01",
    title: "El cobrador avergonzado",
    body: "A las Mypes les cuesta pedir su propio dinero. Llamadas incómodas, mensajes que no sabes cómo redactar, clientes que se ofenden. El resultado: el 43% de las facturas de microempresas en LatAm se pagan tarde.",
  },
  {
    id: "manifesto-chapter-02",
    num: "02",
    title: "El motor invisible",
    body: "YateAviso cobra por ti con amabilidad y firmeza. Secuencias automáticas por WhatsApp con el tono exacto: cordial antes del vencimiento, claro el día D, insistente después. Tu cliente siente que le escribes tú.",
  },
  {
    id: "manifesto-chapter-03",
    num: "03",
    title: "La tranquilidad de caja",
    body: "Recupera hasta 14 horas a la semana que hoy gastas persiguiendo pagos. Tu flujo de caja se vuelve predecible y tú vuelves a lo tuyo: hacer crecer tu negocio.",
  },
];

export const ManifestoChapters = () => (
  <section id="manifiesto" data-testid="manifesto-section" className="mx-auto max-w-6xl px-4 py-24 sm:px-6 lg:py-32">
    <Reveal>
      <p className="mono mb-4 text-xs uppercase tracking-[0.2em] text-emerald-400">Manifiesto</p>
      <h2 className="font-display max-w-2xl text-2xl font-bold leading-snug tracking-tight sm:text-3xl lg:text-4xl">
        Tres verdades que todo dueño de Mype conoce demasiado bien.
      </h2>
    </Reveal>

    <div className="mt-16 space-y-0">
      {CHAPTERS.map((c, i) => (
        <Reveal key={c.id} delay={i * 0.1}>
          <article
            data-testid={c.id}
            className="group grid grid-cols-12 items-start gap-4 border-t border-white/10 py-10 transition-colors duration-500 hover:bg-white/[0.02] lg:gap-8"
          >
            <span className="text-outline font-display col-span-3 text-5xl font-black transition-all duration-500 group-hover:[-webkit-text-stroke:1px_#10B981] sm:col-span-2 sm:text-6xl lg:text-7xl">
              {c.num}
            </span>
            <h3 className="font-display col-span-9 text-xl font-semibold tracking-tight sm:col-span-4 sm:text-2xl">
              {c.title}
            </h3>
            <p className="col-span-12 text-sm leading-relaxed text-slate-400 sm:col-span-6 sm:text-base">
              {c.body}
            </p>
          </article>
        </Reveal>
      ))}
    </div>
  </section>
);
